module.exports = __webpack_public_path__ + "./assets/icons/gift.svg";